import React, { useState } from "react";
import { Card, Tag, Rate } from "antd";
import { getNameInitials, formatDateTimeOrNull } from "utils/index";
import IndexModal from "components/modal";
import CandidateScoreCard from "./CandidateScoreCard";
import { displayIcon } from "variables/icons";

const ApplicantCard = ({
    recordData,
    skills = [],
    onClick,
    selected = false,
    key,
    authUser,
}) => {

    const [showScoreDetails, setShowScoreDetails] = useState(false);

    return (
        <Card
            key={key}
            hoverable
            onClick={onClick}
            className={`!rounded-2xl !border-2 transition-all duration-300 cursor-pointer ${
                selected
                    ? "!border-emerald-500 !bg-gradient-to-br from-emerald-50 to-cyan-50"
                    : "!border-slate-200 hover:!border-emerald-300"
                }`}
        >
            <div className="flex flex-col space-y-3">
                <div className="flex justify-between items-start">
                    <div className="flex items-start gap-3">
                        <span 
                            className={`relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full border-2 border-white shadow-md  ${
                                selected
                                    ? "bg-gradient-to-br from-emerald-500 to-cyan-500"
                                    : "bg-emerald-100"
                                }`}
                        >
                            <span className={`flex size-full items-center justify-center font-semibold text-[14px] ${
                                selected
                                    ? "text-white"
                                    : "text-emerald-800"
                                }`}
                            >
                                { getNameInitials(recordData?.name) }
                            </span>
                        </span>

                        <div className="flex-1 min-w-0">
                            <h4 className={`font-semibold text-[13px] sm:text-[15px] text-slate-900`}>
                                {recordData?.name}
                            </h4>
                            <p className="text-[12px] text-slate-700">{recordData?.job_post_title}</p>

                            <div className="flex items-center gap-3 text-[12px] text-slate-700 mt-1">
                                {recordData?.applicant_location && (
                                    <span className="flex items-center gap-1">
                                        {displayIcon("MapPin","w-3 h-3 text-gray-400")}
                                        {recordData.applicant_location}
                                    </span>
                                )}
                                {recordData?.apl_xp_years && (
                                    <span className="flex items-center gap-1">
                                        {displayIcon("Clock","w-3 h-3 text-slate-700")}
                                        {recordData.apl_xp_years} yrs
                                    </span>
                                )}
                            </div>
                        </div>

                    </div>
                    <div className="">
                        <p className="text-[12px] text-slate-700">Registered: {formatDateTimeOrNull(recordData?.created_at, "YYYY-MM-DD")}</p>
                    </div>
                </div>
                
                {recordData?.skills?.length > 0 && (
                    <div className="flex flex-wrap gap-1">
                        {recordData.skills.slice(0, 3).map((skill, i) => (
                            <Tag
                                key={i}
                                className="!text-[11px] !py-0.5 !px-2 !rounded-lg !bg-gray-50 !border-none !text-gray-800"
                            >
                                {skill}
                            </Tag>
                        ))}
                        {recordData.skills.length > 3 && (
                            <Tag className="!text-[11px] !py-0.5 !px-2 !rounded-lg !bg-gray-50 !border-none !text-gray-800">
                                +{skills.length - 3} more
                            </Tag>
                        )}
                    </div>
                )}

                <div className="w-full">
                    <div class="font-semibold">Applications</div>
                    <div className="flex flex-wrap gap-2">
                    {recordData?.job_applications?.map((application, i) => (
                        <div className="flex gap-2 rounded-lg p-1 bg-gradient-to-br from-emerald-200 to-cyan-200">
                            <div className="p-1">{application.job_post.jpo_title}</div>
                            <div className={`pipeline-steps text-white rounded-lg p-1 px-2 ${application.pipeline_name?.toLowerCase().replace(/\s+/g, '-')}`}>{application.pipeline_name}</div>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
            <IndexModal
                open={showScoreDetails}
                onClose={() => setShowScoreDetails(false)}
                title={`${recordData?.applicant_name} Scores`}
                width={800}
            >
                <div>
                    <CandidateScoreCard scoreData={recordData?.applicant_score} isClientUser={authUser?.user_level === 4}/>
                </div>
            </IndexModal>
        </Card>
    );
};



export default ApplicantCard;
